import React from 'react';
import EnquiryForm from "../components/enquiryForm/EnquiryForm";

const ContactMe = () => {
  return (
    <section>
      <h1>Lets keep in touch</h1>
      <EnquiryForm />
    </section>
  )
};

export default ContactMe;
